<div class="flash-message-container">
  <flash-message></flash-message>
</div>

<div class="row">
  <div class="col-xs-12">
    <div class="panel panel-default no-margin">
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.tipo.$invalid}">
              <label for="tipo">Tipo</label>
              <ui-select ng-model="newOcorrencia.tipo" theme="bootstrap" id="tipo" name="tipo" required>
                <ui-select-match allow-clear="true" placeholder="Selecione o Tipo...">{{$select.selected.descricao | capitalize}}</ui-select-match>
                <ui-select-choices repeat="tipo in tiposOcorrenciasMaquinas | filter: $select.search">
                  <span class="form-group" ng-bind-html="tipo.descricao | capitalize | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.safra.$invalid}">
              <label for="safra">Safra</label>
              <ui-select ng-model="newOcorrencia.safra" theme="bootstrap" id="safra" name="safra" required>
                <ui-select-match allow-clear="true" placeholder="Selecione o safra...">{{$select.selected.descricao}}</ui-select-match>
                <ui-select-choices repeat="safra in safras | orderBy: '-descricao' | filter: $select.search">
                  <span class="form-group" ng-bind-html="safra.descricao | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>

          <div class="col-xs-3 col-md-2">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.data.$invalid}">
              <label for="data">Data</label>
              <div class="input-group">
                <input type="text" class="form-control" readonly datepicker-options="startDatePickerOptions" placeholder="Data"
                  uib-datepicker-popup="dd/MM/yyyy" ng-model="newOcorrencia.data" id="data" name="data" required
                  is-open="popupData.opened" show-button-bar="false" datepicker-append-to-body="true" ng-change="setMinDueDate()">
                <span class="input-group-btn">
                  <button type="button" class="btn btn-default" ng-click="popupData.opened = !popupData.opened">
                    <i class="glyphicon glyphicon-calendar"></i>
                  </button>
                </span>
              </div>
              <p class="help-block" ng-show="ocorrencia_maquina_form.data.$dirty && ocorrencia_maquina_form.data.$error.required">Informe a data</p>
            </div>
          </div>

          <div class="col-xs-3 col-md-2">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.hora.$invalid}">
              <label for="hora">Hora</label>
              <input type="time" class="form-control" ng-model="newOcorrencia.hora" id="hora" name="hora" required>
            </div>
          </div>

          <div class="col-xs-3 col-md-2">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.dataPrazo.$invalid}">
              <label for="dataPrazo">Data Prazo</label>
              <div class="input-group">
                <input type="text" class="form-control" readonly datepicker-options="dueDatePickerOptions" placeholder="Data"
                  uib-datepicker-popup="dd/MM/yyyy" ng-model="newOcorrencia.dataPrazo" id="dataPrazo" name="dataPrazo"
                  is-open="popupDataPrazo.opened" show-button-bar="false" datepicker-append-to-body="true" required>
                <span class="input-group-btn">
                  <button type="button" class="btn btn-default" ng-click="popupDataPrazo.opened = !popupDataPrazo.opened">
                    <i class="glyphicon glyphicon-calendar"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.maquina.$invalid}">
              <label for="maquina">Máquina</label>
              <ui-select ng-change="changeMaquina(newOcorrencia.maquina)" ng-model="newOcorrencia.maquina" theme="bootstrap" id="maquina" name="maquina" required>
                <ui-select-match allow-clear="true" placeholder="Selecione a Máquina...">{{$select.selected.descricao | capitalize}}</ui-select-match>
                <ui-select-choices repeat="maquina in maquinas | filter: $select.search | limitTo: 50">
                  <span class="form-group" ng-bind-html="maquina.descricao | capitalize | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>
          <div ng-show="newOcorrencia.maquina.grupo.descricao !== 'IMPLEMENTOS'">
            <div class="col-xs-6 col-md-3">
              <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.hodometro.$invalid}">
                <label for="hodometro">{{tiposControleMaquina[newOcorrencia.maquina.tipo_controle_manutencao] || 'Selecione uma Máquina'}}</label>
                <input ng-required="newOcorrencia.maquina.grupo.descricao !== 'IMPLEMENTOS'" type="number" class="form-control" ng-model="newOcorrencia.hodometro" autocomplete="off"
                      pattern="\d+" id="hodometro" name="hodometro" min="1" ng-disabled="newOcorrencia.id">
              </div>
            </div>

            <div class="col-xs-6 col-md-3">
              <br>
              <div class="checkbox">
                <label>
                  <input type="checkbox" ng-model="newOcorrencia.maquinaParada" id="maquina-parada" name="maquina-parada">
                  Máquina Parada?
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-6" ng-show="newOcorrencia.maquina.grupo.descricao === 'IMPLEMENTOS'">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.operador.$invalid}">
              <label for="operador">Operador</label>
              <ui-select ng-model="newOcorrencia.operador" theme="bootstrap" id="operador" name="operador" required>
                <ui-select-match allow-clear="true" placeholder="Selecione o Operador...">{{$select.selected.nome | capitalize}}</ui-select-match>
                <ui-select-choices repeat="operador in operadores | filter: $select.search | limitTo: 50">
                  <span class="form-group" ng-bind-html="operador.nome | capitalize | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>

        </div>

        <div class="row" ng-hide="newOcorrencia.maquina.grupo.descricao === 'IMPLEMENTOS'">
          <div class="col-md-6">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.operador.$invalid}">
              <label for="operador">Operador</label>
              <ui-select ng-model="newOcorrencia.operador" theme="bootstrap" id="operador" name="operador" required>
                <ui-select-match allow-clear="true" placeholder="Selecione o Operador...">{{$select.selected.nome | capitalize}}</ui-select-match>
                <ui-select-choices repeat="operador in operadores | filter: $select.search | limitTo: 50">
                  <span class="form-group" ng-bind-html="operador.nome | capitalize | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group" ng-class="{'has-error': ocorrencia_maquina_form.relato.$invalid}">
              <label for="relato">Relato</label>
              <input class="form-control" ng-model="newOcorrencia.relato" autocomplete="off"
                     type="text" id="relato" name="relato" placeholder="Motivo da Parada" required>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="itens_manutencao">Itens de Manutenção</label>
              <ui-select required multiple ng-model="newOcorrencia.itensManutencao" theme="bootstrap" id="itens_manutencao" name="itens_manutencao" close-on-select="false">
                <ui-select-match placeholder="">{{$item.descricao | capitalize}}</ui-select-match>
                <ui-select-choices repeat="item in itensManutencao | filter: $select.search">
                  <span class="form-group" ng-bind-html="item.descricao | capitalize | highlight: $select.search"></span>
                </ui-select-choices>
              </ui-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
